import { BRAND_LOGO_SRC, BRAND_NAME } from "@/lib/brand";

const SIZES = {
  xs: 24,
  sm: 28,
  md: 32,
  lg: 40,
  xl: 64,
};

const TEXT_SIZES = { xs: 16, sm: 18, md: 20, lg: 24 };

/**
 * PaisaCX logo: emerald mark with optional "Paisacx" wordmark.
 * @param {{ size?: keyof typeof SIZES | number, className?: string, alt?: string, testId?: string, wordmark?: boolean }} props
 */
export default function BrandLogo({
  size = "md",
  className = "",
  alt = BRAND_NAME,
  testId,
  wordmark = true,
}) {
  const dim = typeof size === "number" ? size : SIZES[size] ?? SIZES.md;
  const textSize = TEXT_SIZES[size] ?? Math.round(dim * 0.6);

  return (
    <span
      data-testid={testId}
      aria-label={alt}
      className={`inline-flex shrink-0 items-center gap-1 ${className}`}
    >
      <img
        src={BRAND_LOGO_SRC}
        alt=""
        width={dim}
        height={dim}
        className="block shrink-0 object-contain"
        style={{ width: dim, height: dim }}
        draggable={false}
      />
      {wordmark ? (
        <span
          aria-hidden
          className="font-display font-bold leading-none tracking-tight text-foreground"
          style={{ fontSize: textSize }}
        >
          Paisa<span className="brand-text">cx</span>
        </span>
      ) : null}
    </span>
  );
}
